import type { Ref } from 'vue'

import { isRef, onBeforeUnmount, onMounted, shallowRef } from 'vue'

export const useScrollReveal = (
  targetOrThreshold: number | Ref<HTMLElement | null> = 0.1,
  threshold = 0.1
) => {
  let targetRef: Ref<HTMLElement | null>
  let actualThreshold = threshold
  let observer: IntersectionObserver | undefined

  if (isRef(targetOrThreshold)) {
    targetRef = targetOrThreshold
  } else {
    targetRef = shallowRef(null)
    if (typeof targetOrThreshold === 'number') {
      actualThreshold = targetOrThreshold
    }
  }

  const isVisible = shallowRef(false)

  onMounted(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      isVisible.value = true
      return
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          isVisible.value = true
          observer.unobserve(entry.target)
        })
      },
      { threshold: actualThreshold }
    )

    if (targetRef.value) observer.observe(targetRef.value)
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
  })

  return {
    targetRef,
    isVisible,
  }
}
